import { useEffect } from 'react'
import { soundFx } from '../lib/soundEffects'

/**
 * Global Audio Listener 🎧
 * "The Coach Whisperer Layer"
 * 
 * Listens to all clicks in the app.
 * If a click hits an interactive element (button, link) AND hasn't been handled 
 * by a specific premium component sound, it plays a subtle fallback sound.
 * 
 * This ensures the ENTIRE app feels alive, even standard HTML buttons.
 */
export const GlobalAudioListener = () => {
    useEffect(() => {
        const handleClick = (e) => {
            // 1. Check if already handled by a Premium Component (Button, NavItem, etc)
            if (e.audioplayed) return

            // 2. Identify interactive elements
            // Note: We use .closest() to find the parent button if user clicks on an icon inside
            const target = e.target.closest('button, a, input[type="submit"], input[type="button"], [role="button"], select')

            if (target) {
                // Ignore disabled elements
                if (target.disabled || target.getAttribute('aria-disabled') === 'true' || target.classList.contains('disabled')) {
                    return
                }

                // Play the "Standard Interaction" sound
                // Using 'hover' from engine (short tick) or 'click' (crisp sine)
                // Let's use 'hover' as it is less intrusive for "everything"
                // Or maybe create a dedicated 'tick' in SoundEngine later.
                // For now, 'hover' (triangle wave 20ms) is perfect for a "tick".
                soundFx.play('hover')
            }
        }

        // Listen on document level (bubbling phase)
        document.addEventListener('click', handleClick)

        return () => {
            document.removeEventListener('click', handleClick)
        }
    }, [])

    return null
}
